import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Divider } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import empresaApi from '../../api/empresaApi';

const EmpresaDetailList = ({ onLineaNegocioSelection, onDashboardSelection, lineasSeleccionadas, dashboardsPreseleccionados }) => {
    const [empresas, setEmpresas] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await empresaApi.getempresaDetail();
                setEmpresas(data);
            } catch (error) {
                console.error('Error al obtener los datos de la empresa:', error);
            }
        };
        fetchData();
    }, []);

    const handleLineaNegocioSelection = (lineaNegocio) => {
        // Si la línea de negocio está seleccionada, la quitamos, de lo contrario la agregamos
        if (lineasSeleccionadas.some((linea) => linea.id === lineaNegocio.id)) {
            onLineaNegocioSelection(prevLineas => prevLineas.filter((linea) => linea.id !== lineaNegocio.id));
        } else {
            onLineaNegocioSelection(prevLineas => [...prevLineas, lineaNegocio]);
        }
    };

    const handleDashboardSelection = (dashboard) => {
        // Si el dashboard está seleccionado, lo quitamos, de lo contrario lo agregamos
        if (dashboardsPreseleccionados.some((dash) => dash.id === dashboard.id)) {
            onDashboardSelection(prevDash => prevDash.filter((dash) => dash.id !== dashboard.id));
        } else {
            onDashboardSelection(prevDash => [...prevDash, dashboard]);
        }
    };

    return (
        <div>
            {empresas.map((empresa) => (
                <Accordion key={empresa.id}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">{empresa.empresa}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List>
                            {empresa.lineas_negocio.map((lineaNegocio) => (
                                <div key={lineaNegocio.id}>
                                    <ListItem>
                                        <ListItemText primary={lineaNegocio.linea_negocio} />
                                        <Checkbox
                                            checked={lineasSeleccionadas.some((linea) => linea.id === lineaNegocio.id)}
                                            onChange={() => handleLineaNegocioSelection(lineaNegocio)}
                                        />
                                    </ListItem>
                                    <List sx={{ ml: 2 }}>
                                        {lineaNegocio.dashboards.map((dashboard) => (
                                            <ListItem key={dashboard.id}>
                                                <ListItemText primary={dashboard.name} />
                                                <Checkbox
                                                    checked={dashboardsPreseleccionados.some((dash) => dash.id === dashboard.id)}
                                                    onChange={() => handleDashboardSelection(dashboard)}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                    <Divider />
                                </div>
                            ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default EmpresaDetailList;
